<template>
  <div id="app">
    <!-- <router-view/> -->
    <home></home>
    <!--电信用户登录页导航-->
    <!-- <HomeAd v-else></HomeAd> -->
  </div>
</template>

<script>
import { login, getwebid } from "@/services/api.js";
import { mapGetters, mapActions } from "vuex";
import {
  getModulStyle,
  getWebModels,
  getModuleInfo,
  getdoctitle,
  getColumnSwitch
} from "@/services/api.js";
import imgCardVue from "./components/imgCard.vue";
import Home from "./page/Home.vue";
import HomeAd from "./page/homeAd.vue"; //电信用户登录页导航
export default {
  name: "App",
  data() {
    return {
      showType: false,
      domainName: "localhost", //电信域名
      valtitle: ""
    };
  },
  components: {
    Home,
    HomeAd
  },
  watch: {
    webID() {
      getModulStyle(`web_id=${this.webID}&user_sort=1`).then(res => {
        if (res.status_code == 1) {
          this.setModelsInfo(res.data);
          // this.setCurModelInfo(res.data[0]);
          this.getdoctitle();
        }
      });
      let data = {
        web_id: this.webID
      };
      getWebModels(data).then(res => {
        if (res.status_code == 1) {
          this.setWebModels(res.data.list);
        }
      });
    }
  },
  mounted() {
    this.setExample("改变了");
    //判断是否是高能所
    this.setisGaonS();
    console.log(`是否高能所`);
    console.log(this.isGaonS);
    if (this.isGaonS) {
      //是高能所页面
      //判断当前模式 中文or英文
      this.setisEnglish(false);
      console.log(`是否英文`);
      console.log(this.isEnglish);
    }
  },
  computed: {
    ...mapGetters(["example", "webID", "isGaonS", "isEnglish", "showPeople"])
  },
  created() {
    console.log(window.location.host, "this.webID");

    // if (
    //   window.location.host == "cpad.vcg.com" &&
    //   !window.sessionStorage.getItem("token")
    // ) {
    //   this.$router.push({ path: "/noLoginModelFP" });
    //   return;
    // } else if (
    //   this.webID == 111142 &&
    //   !window.sessionStorage.getItem("token")
    // ) {
    //   this.$router.push({ path: "/noLoginModelFP" });
    //   return;
    // }

    //判断是否是电信用户
    // this.getDomainName();
    this.setWebId({ domainName: window.location.host });
    this.setHideFooter(window.location.host);
    getwebid({ domainName: window.location.host }).then(x => {
      getColumnSwitch({
        customer_id: x.data
      }).then(res => {
        // debugger
        this.set_column_switch_action(res.data);
      });
    });
  },
  methods: {
    ...mapActions([
      "setExample",
      // "setCurModelInfo",
      "setModelsInfo",
      "setWebModels",
      "setWebId",
      "setHideFooter",
      "set_column_switch_action",
      //是否是高能所
      "setisGaonS",
      //是否是英文
      "setisEnglish"
    ]),
    //判断是否是电信用户
    getDomainName() {
      if (window.location.host.indexOf(this.domainName) > -1) {
        if (!sessionStorage.getItem("token")) {
          this.$router.push({ name: "LoginAd" });
        }
        this.showType = false;
        //如果是
      } else {
        this.showType = true;
        // this.$router.push({name: 'Login'})   //如果不是
      }
    },
    getdoctitle() {
      getdoctitle({ uid: this.webID }).then(x => {
        if (this.isGaonS) {
          //如果是高能所就分割字符串
          this.valtitle = x.data.customName.split("*##*");
          if (this.isEnglish) {
            //如果是英文模式就取后面
            document.title = this.valtitle[1];
          } else {
            document.title = this.valtitle[0];
          }
        } else {
          document.title = x.data.customName;
        }
        let oauth_status = x.data.oauth_status;
        if (oauth_status == 1) {
          //接入
          let oauth_token_url = x.data.oauth_token_url;
        } else {
          //未接入
        }
        if (x.status_code == 1) {
          //等于1 显示我们这几天做过的  等于0 不显示我们这几天做的
          let v = x.data.payment; //租户支付功能开关 0 关闭, 1 打开
          //保存在store中
          this.$store.commit("controller/changePayment", v);
          window.localStorage.setItem("payment", v);
        }
      });
    }
  }
};
</script>

<style lang="less">
.el-header {
  padding: 0px !important;
}
.el-footer {
  padding: 0;
  background-color: #fff;
  /* background-color: #4F4F4F; */
  position: relative;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue